import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import {
  EmptyStateUniDriver,
  TextButtonUniDriver,
} from '@wix/design-system/dist/testkit/unidriver';

export function ToolbarCollectionErrorStateUniDriver(
  base: UniDriver,
  body: UniDriver,
) {
  return {
    ...EmptyStateUniDriver(base, body),

    getButtonByDataHook: (dataHook: string) =>
      TextButtonUniDriver(base.$(`[data-hook="${dataHook}"]`), body),

    getRetryButton: () =>
      TextButtonUniDriver(base.$('[data-hook="retry-button"]'), body),
  };
}
